var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.nodes),function(node,name){return _c('TreeNode',{key:name,attrs:{"node":node,"nodeName":name,"selectedNodes":_vm.selectedNodes},on:{"selectTreeCategory":_vm.handleSelectTreeCategory}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }